import React, { Component } from 'react';
import Radiobutton from './../Radio';

class OrderTabQAItem extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.renderRow = this.renderRow.bind(this);
  }

  onChange(event) {
    const { onChange } = this.props;
    const value = event.target.value;
    const name = event.target.name;    
    onChange(name, value);
  }

  saveReport(newFormData) {
    const report = [];
    const arReportData = Object.values(newFormData);
    const { updateOrderReport } = this.props;

    arReportData.map(itemValue => (
      report.push(itemValue.join(':'))
    ));

    updateOrderReport(report);
  }

  renderRow(tableRow) {
    const { dataRow, avg } = this.props;
    const { id } = tableRow;

    if (!!Object.keys(dataRow).length && dataRow[id]) {
      return (
        <tr key={id}>
          <td>
            <span dangerouslySetInnerHTML={{ __html: tableRow.name }} />
            <div className="tooltip">
              <span className="tooltip_trigger" />
              <div className="tooltip_content" dangerouslySetInnerHTML={{ __html: tableRow.tooltip }} />
            </div>
          </td>
          {Object.values(tableRow.value).map((itemValue, index) =>
            <td key={id + '_' + index}>
              <Radiobutton
                disabled={!this.props.isEdit}
                onChange={this.onChange}
                name={id}
                value={index}
                checked={dataRow[id].data[index]}
              >
              {index !== 4 && itemValue}
              </Radiobutton>
            </td>
          )}
          {/* <td><div className="na_element"><Radiobutton disabled={!this.props.isEdit} onChange={this.onChange} value="4" name={id} checked={false} /></div></td> */}
        </tr>
      );
    }
    else {
      return (
        <tr key={id}>
          <td>
            <span dangerouslySetInnerHTML={{ __html: tableRow.name }} />
            <div className="tooltip">
              <span className="tooltip_trigger" />
              <div className="tooltip_content" dangerouslySetInnerHTML={{ __html: tableRow.tooltip }} />
            </div>
          </td>
          {Object.values(tableRow.value).map((itemValue, index) =>
            <td key={id + '_' + index}>
              {index !== 4 &&
                <Radiobutton disabled={!this.props.isEdit} onChange={this.onChange} name={id} value={index} checked={false}>{itemValue}</Radiobutton>
              }
              {index === 4 &&
                <Radiobutton disabled={!this.props.isEdit} onChange={this.onChange} name={id} value={index} checked={!!avg} />
              }
            </td>
          )}
          {/* <td><div className="na_element"><Radiobutton disabled={!this.props.isEdit} onChange={this.onChange} value="4" name={id} checked={false} /></div></td> */}
        </tr>
      );
    }
  }

  render() {
    const { dataSection } = this.props;

    return (
      <div>
        <table>
          <tbody>
            <tr>
              <th>Criterion</th>
              <th>Yes</th>
              <th>Mostly</th>
              <th>Poorly</th>
              <th>No</th>
              <th>N/A</th>
            </tr>
            {Object.values(dataSection).map(this.renderRow)}
          </tbody>
        </table>
      </div>
    );
  }
}

export default OrderTabQAItem;



// WEBPACK FOOTER //
// ./src/components/order/OrderTabQAItem.js